import React, { useEffect, useState } from "react";
import Axios from "../../../services/AxiosInstance";
import ReactPaginate from 'react-paginate';
import { useNavigate } from 'react-router-dom';


const UpdateServiceName = (props) => {

    const [updateServiceName, setUpdateServiceName] = useState(props.serviceName);
    const Navigate = useNavigate();

    const updateServiceApi = () => {
        console.log(updateServiceName, props.serviceId);
        Axios
            .post(`api/bussiness/service-edit-name?service_id=${props.serviceId}`, {
                service_name: updateServiceName,
            })
            .then((response) => {
                console.log(response);
                props.setIsNameUpdated(true);
            }).catch((error) => {
                alert(error.response.data.message);
            });
    }
    return (
        <>
            <div className="col-md-6 col-xl-3">
                <div className="card-box">
                    <div className="form-group mb-0 text-center">
                        <div className="form-group mb-3">
                            <label htmlFor="group-name">Service Name</label>
                            <input
                                onChange={(e) => setUpdateServiceName(e.target.value)}
                                id="group-name"
                                value={updateServiceName}
                                type="text"
                                className="form-control"
                                placeholder="Enter Service Name"
                            />
                        </div>
                    </div>
                    <div className="row mt-4">
                        <div className="form-group mb-0 text-center">
                            <button onClick={updateServiceApi} className="btn btn-gradient btn-block" type="submit"> Update Service Name </button>
                            <h2 onClick={() => props.setEditName(false)}>x</h2>
                        </div>

                    </div>  </div>
            </div>
        </>
    )
}

export default UpdateServiceName;